import { Component, OnInit } from '@angular/core';
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "../common.service";
declare var jQuery:any;
declare var $ :any;
declare var polyvObject :any;
declare var window :any;

@Component({
  selector: 'app-case-practice-team',
  templateUrl: './case-practice-team.component.html',
  styleUrls: ['./case-practice-team.component.css']
})
export class CasePracticeTeamComponent implements OnInit {
  page:string;
  pageToVideo: string;
  practiceMetaId: number;
  learningPathId: number;
  methodId: number;
  multiExerciseMetaId: any;
  showCloseBtn:Boolean;
  isPC: boolean = false;
  type : string
  constructor(private apiService: ApiService,
              private route: ActivatedRoute,
              private router: Router,
              private commonService: CommonService
              ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(queryParams=>{
      this.type = queryParams['type']
      if(this.type){
        localStorage.setItem('isPC',this.type);
      }
    })
    this.route.params.subscribe(params => {
      console.log(params);
      this.practiceMetaId = params['practiceMetaId'];
      this.learningPathId = params['learningPathId'];
      this.methodId = params['methodId'];
      this.isPC = !!localStorage.getItem('isPC');
      if(localStorage.getItem('isIframe')){
        this.goToNextStep(1);
      }
      else if(this.methodId==1){
        this.page = 'list';
      }else if(this.methodId==2){
        this.page = 'video';
        this.pageToVideo = 'begin';
        this.multiExerciseMetaId = params['multiExerciseMetaId'];
      }else if(this.methodId==3){
      	//新增特殊场景
        this.page = 'video';
        this.pageToVideo = 'begin';
        this.showCloseBtn = true;
        this.multiExerciseMetaId = params['multiExerciseMetaId'];
      }
    });

    setTimeout(()=>{
      if(this.type){
        $('#userIdContainer').val(JSON.parse(localStorage.getItem('userInfo'))['userId']);
      }
    },500);
  }

  goToVideo(page){
    this.page = 'video';
    this.pageToVideo = page;
  }

  goToQuestion(){
    this.page = 'question';
  }

  goToBegin(){
    let link = ['case-practice-team-begin', this.multiExerciseMetaId, this.learningPathId, this.practiceMetaId];
    if(this.type){
      this.router.navigate(link,{queryParams:{type:'huatek'}});
    }else{
      this.router.navigate(link);
    }
  }

  goToMain(typeId){
    let link = ['case-practice-team-main', typeId, this.learningPathId, this.practiceMetaId];
    if(this.type){
      this.router.navigate(link,{queryParams:{type:'huatek'}});
    }else{
      this.router.navigate(link);
    }
  }

  goToNextStep(step){
    if(step==1){

      this.page = 'video';

    }else if(step==2){

      this.page = 'question';

    }else if(step==3){
      this.route.params.subscribe(params=>{
        if(this.type === 'huatek'){
          this.multiExerciseMetaId = 1;
        }
        let link = ['case-practice-team-begin', this.multiExerciseMetaId,this.learningPathId,this.practiceMetaId];
        if(this.type){
          this.router.navigate(link,{queryParams:{type:'huatek'}});
        }else{
          this.router.navigate(link);
        }
      })
      let exerciseMetaId=$('#exerciseMetaId').val()
      this.apiService.learingTime({learningPathMetaId:localStorage.getItem("learningPathMetaId"),module:'情景模拟',courseUnit:'',type:1,btnName:'41',userId:localStorage.getItem("userId")}).subscribe(result=>{
        console.log(result)
      })
      console.log(exerciseMetaId)
      this.commonService.sendPostMessage(0,'isPractice' +'Complete')
    }

  }

  setMultiExerciseMetaId(id){
      this.multiExerciseMetaId = id;
  }

}



// WEBPACK FOOTER //
// ./src/app/case-practice-team/case-practice-team.component.ts